import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Column } from 'react-table'
import { StatusCell } from './StatusCell'
import { SyncStatusCell } from './SyncStatusCell'
import { StartDateCell } from './StartDateCell'
import { PatientGenderCell } from './PatientGenderCell'
import { PatientNameCell } from './PatientNameCell'
import { PatientSurnameCell } from './PatientSurnameCell'

export function useColumns() {
  const { t } = useTranslation()

  return useMemo(
    () =>
      [
        {
          Header: t('field.name.label').toUpperCase(),
          accessor: 'patient.userInfo.surname',
          Cell: PatientSurnameCell,
        },
        {
          Header: t('field.firstName.label').toUpperCase(),
          accessor: 'patient.userInfo.name',
          Cell: PatientNameCell,
        },
        {
          Header: t('field.gender.label').toUpperCase(),
          accessor: 'patient.userInfo.gender',
          Cell: PatientGenderCell,
        },
        {
          Header: t('page.consultations.table.header.startDate').toUpperCase(),
          accessor: 'startDate',
          Cell: StartDateCell,
        },
        {
          align: 'center' as const,
          Header: t('page.consultations.table.header.status').toUpperCase(),
          accessor: 'status',
          Cell: StatusCell,
        },
        {
          align: 'center' as const,
          Header: t('sync.consultations.table.syncStatus'),
          accessor: '_syncStatus',
          Cell: SyncStatusCell,
        },
      ] as Column<any>[],
    [t]
  )
}
